import { Button, Row, Tag } from "antd";
import { ScrollableWrapper } from "../ScrollableWrapper";
import styled, { createGlobalStyle } from "styled-components";

export const Wrapper = styled(ScrollableWrapper)`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${"#EAEDF5"};
  padding-top: 24px;
  margin-top: 24px;

  > .ant-row {
    padding: 4px 0;
  }
`;

export const ButtonRow = styled(Row)`
  margin-top: 24px;
  border-top: 1px solid ${"#EAEDF5"};
  padding-top: 24px;
`;

export const StyledTag = styled(Tag)`
  margin: 0;
`;

export const StyledButton = styled(Button)`
  font-weight: 500;
  line-height: 24px;
  height: 24px;

  &.ant-btn.ant-btn-link {
    padding: 0;
  }
`;

export const GlobalModalStyles = createGlobalStyle`
  .ant-modal.contractors-modal {
    margin: 15% auto;
    width: 720px !important;
    padding: 0;

    .ant-modal-title .ant-row {
      margin: 0;

      .ant-typography {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;
